import React from "react";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import formatContentfulRichText from "@qlik/qlik/src/lib/format-rich-text-content";
import * as styles from "./styles.module.css";

/**
 * RichText component
 * This component is used to render the rich text content from Contentful.
 * @param {Object} data - The data object containing the rich text content.
 * @param {string} className- The class name(s) to be used in the wrapper.
 * @returns {JSX.Element} The rendered RichText component.
 */
const RichText = ({ data, className }) => {
    return (
        <div className={`rich-text-body ${styles.richtextWrapper} ${className}`}>
            {data.body?.raw && renderRichText(data?.body, formatContentfulRichText())}
        </div>
    );
};

// Exporting the RichText component
export default RichText;
